export default __webpack_public_path__ + "static/media/devteamgenerator.02a86523.png";